import Link         from 'next/link';
import cx           from 'classnames';
import { ymElem }   from '../utils/helpers';
import { trackEvent }                       from '../utils/tracking'

const CarItem = ({ info, lang }) => {
    let badgeCSS = cx({
        logo: true,
        green: info.colorBadge === 'green',
        orange: info.colorBadge === 'orange',
    });

    let carIcon = cx({
        'car-icon': true,
        [info.icon]: true,
    });

    return (
        <div key={'key-' + info.id} className="car-item">
            <div className="container">
                <div className="car-item-row">
                    <div className={carIcon} />
                    <div className="car-name">{info.name}</div>
                    <div className="car-type">{info.type}</div>
                    <div className="car-tariff">
                        <div className="car-tariff-icon"/>
                        <div className="car-tariff-title">{lang.Tariff}:</div>
                        <div className="car-tariff-name">{info.tariff}</div>
                    </div>

                    <Link href="/tariff">
                        <a className="car-take-order" title={lang.checkPrice} onClick={() => trackEvent('get_price')}>{lang.checkPrice}</a>
                    </Link>
                </div>
                <div className="car-item-row-params">
                    <div className="car-item-row-params-image" style={{backgroundImage: 'url("' + info.photo + '")'}} />
                    <div className="car-item-row-params-box-size">
                        <span className="value">{info.params.volume} <span className="unit">{lang.TariffCountM}<sup><small>3</small></sup></span></span>
                    </div>
                    <div className="car-item-row-params-values">
                        <div className="title">{lang.Tariff_table_1_desc_0}</div>
                        <div className="car-info">
                            <div className="car-info-icon weight"/>
                            <div className="car-info-title">{lang.Tariff_table_1_desc_2}</div>
                            <div className="car-info-value">{info.params.weight} {lang.TariffCountT}</div>
                        </div>
                        <div className="car-info">
                            <div className="car-info-icon height"/>
                            <div className="car-info-title">{lang.Tariff_table_1_desc_3_3}</div>
                            <div className="car-info-value">{info.params.height} {lang.TariffCountM}</div>
                        </div>
                        <div className="car-info">
                            <div className="car-info-icon long"/>
                            <div className="car-info-title">{lang.Tariff_table_1_desc_3_1}</div>
                            <div className="car-info-value">{info.params.long} {lang.TariffCountM}</div>
                        </div>
                        <div className="car-info">
                            <div className="car-info-icon width"/>
                            <div className="car-info-title">{lang.Tariff_table_1_desc_3_2}</div>
                            <div className="car-info-value">{info.params.width} {lang.TariffCountM}</div>
                        </div>
                        <div className="car-info">
                            <div className="car-info-icon volume"/>
                            <div className="car-info-title">{lang.Tariff_table_1_desc_3_4}</div>
                            <div className="car-info-valueM3">{info.params.volume} {lang.TariffCountM}<sup><small>3</small></sup></div>
                        </div>
                    </div>

                    <div className="car-item-row-params-desc">
                        <div className="title">{lang.CarDescription}</div>
                        <div className="desc">{info.description}</div>
                        <div className="bonus"><span className={badgeCSS}>{info.bonus}</span></div>
                    </div>

                    <div className="clr" />
                </div>
            </div>
        </div>
    );
};

export default CarItem;
